import headerComponent from '@/components/cust_components/cust_header_component.vue';
import utils from '../../js/utils.js';
import 'moment-timezone';
import moment from 'moment';
import InfiniteLoading from 'vue-infinite-loading';
import LoaderPopover from '@/components/loaderpopover_component.vue';
import CustPopover from '@/components/cust_components/cust_popover_component.vue';

export default {
    name: 'previewBooking',
    components:{
       headerComponent,
       InfiniteLoading,
       LoaderPopover,
       CustPopover
    },
    data(){
        return {
            mobile_view : false,
            sorted_array :[],
            start : 0,
            today_date :  this.$store.state.brisbane_today_date,
            today_time :  this.$store.state.brisbane_today_time, 
            initial_load_data : true,
            state:'',
        }
    },
   
    mounted(){
        this.responsive_view();
        window.addEventListener('resize', this.responsive_view);
        this.$session.remove('unpaid_booking_details');
    },  
    methods:{
        async responsive_view(){
            await this.$store.commit('responsive_view', window.innerWidth)
        },
        time_diff_check(date_time)
        {
            let today = moment().tz('Australia/Brisbane').format();  
            let book_date_time =  moment.tz(date_time,'Australia/Brisbane'); 
            let minutes = book_date_time.diff(today,'minutes');
            return minutes;
        },
        async loadMore($state){
            this.$store.state.loader_popup = true;
           
            let cust_details = JSON.parse(this.$session.get('cust_details'));
            this.state = $state;
            await this.$store.dispatch('getUpComingBookingDetails',[this.$store.state.api,cust_details.cust_email, this.start])
            let bookings  = this.$store.state.upcoming_bookingdetails_data;
            let unique_book_ids = {};
            bookings.forEach(service_bookings => {

                service_bookings["book_date_time"] = service_bookings.book_start_date + ' ' + service_bookings.book_start_time ;

                if(!(service_bookings.multi_service_book_id in unique_book_ids)){
                    unique_book_ids[service_bookings.multi_service_book_id] = []
                }

                if(service_bookings.multi_service_book_id !=0){
                    unique_book_ids[service_bookings.multi_service_book_id].push(service_bookings) 
                }
                else{
                    this.sorted_array.push(service_bookings) 
                }
            });

            for (let [book_id,booking_detais] of Object.entries(unique_book_ids)) {
                       
                if(book_id && booking_detais.length>0){
                    this.sorted_array.push(booking_detais[0])
                }

            }

            this.sorted_array.sort(function(a,b){
                return new Date(b.book_date_time) - new Date(a.book_date_time);
            });

            
            if (bookings.length) {
                this.start += 100;
               
                if(bookings.length < 100){
                    $state.complete();
                }else{
                    $state.loaded();
                }
            } else {
                $state.complete();
            }

            this.initial_load_data = false;
           
            this.$store.state.loader_popup = false ;
        },

        async booking_details_redirect(book_id,multi_book_id,store_url_name)
        {
            this.$store.state.loader_popup = true;
            this.$session.set('store_url_name',store_url_name);
            await  this.$store.commit('storeUrlName', store_url_name)
            let cust_details = JSON.parse(this.$session.get('cust_details'));
           
            if(!this.$session.get('store_details')){
                await this.$store.dispatch('getStoreDetails',[this.$store.state.api,this.$store.state.store_url_name])
                let storedetails_array = this.$store.state.cust_store_data;
                this.store_details = JSON.stringify({
                    store_id        :  storedetails_array.store_id,
                    store_name      :  storedetails_array.store_url_name,
                    store_mobile    :  storedetails_array.store_tel,
                });
                this.$session.set('store_details',  this.store_details);
                   
            }
            let store_details = JSON.parse(this.$session.get('store_details'));
            await this.$store.dispatch('checkBlockCustomer',[this.$store.state.api,cust_details.cust_email,store_details.store_id])
            let banned_data = {
        
                "owner_cust_id" : this.$store.state.block_customer_data[0].cust_id,
                "pay_fullpayment" : this.$store.state.block_customer_data[0].pay_fullpayment,
                "cust_banned" :  this.$store.state.block_customer_data[0].is_banned
               
            }
            this.$session.set('cust_banned_data', JSON.stringify(banned_data));
            this.$store.state.loader_popup = false;
            this.$router.push('bookingdetails/service/'+ book_id +"/"+ multi_book_id);
           
   
        },

        categories_redirect()
        {
            this.$router.push('/home/'+ this.$store.state.store_url_name);
        }

 
    },
    filters: {
        human_date_format: function (date,timezone,date_format) {
            return utils.human_date_format(date,timezone,date_format)
        },
        time_12hrs_format:function(time,time_format){
            return utils.time_12hrs_format(time,time_format)
        }

    }
}